import styled from 'styled-components';
import * as bp from 'view/styles/breakpoints';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';

import {
    portalCardsContainerStyle,
    portalCardsContainerWithSidebarStyle,
    customScreenSizeBig,
} from 'view/styles/help-center';
import * as mixins from 'view/styles/mixins';
import { token } from '@atlaskit/tokens';
import { ThemedButton } from '@atlassian/help-center-common-component/themed-button';

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled.div`
    ${mixins.flexCenter};
    flex-direction: column;
    padding: ${token('space.100', '8px')} ${token('space.100', '8px')} ${token('space.600', '48px')}
        ${token('space.100', '8px')};
    align-self: center;
    width: 100%;
    &.sidebar-opened {
        ${portalCardsContainerWithSidebarStyle}
    }
    &.sidebar-closed {
        ${portalCardsContainerStyle}
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const FeaturedAndSortedPortalsListContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 -${grid.multiple(5).px} 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const FeaturedAndSortedPortalsListItem = styled.div`
    display: flex;
    justify-content: center;
    margin: ${token('space.200', '16px')};

    margin: ${token('space.200', '16px')} ${token('space.250', '20px')};

    &.sidebar-opened {
        ${bp.fromCustom(customScreenSizeBig).css`
            margin: ${token('space.200', '16px')} ${grid.multiple(4.75).px};
        `}
    }
    &.sidebar-closed {
        ${bp.fromLarge.css`
            margin: ${token('space.200', '16px')} ${grid.multiple(4.75).px};
        `}
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ProjectsSection = styled.section`
    width: 100%;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
    margin-top: ${token('space.300', '24px')};

    &.expanded-section {
        margin-top: ${token('space.600', '48px')};
    }
`;

// @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation.
// eslint-disable-next-line rulesdir/no-styled-export
export const ExploreAllButton = styled(ThemedButton)`
    && {
        ${fonts.h500};
    }
`;

// @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation.
// eslint-disable-next-line rulesdir/no-styled-export
export const CollapseOtherButton = styled<{ isDisabled: boolean }>(ThemedButton)`
    && {
        ${fonts.h500};
        color: ${(props) => (props.isDisabled ? 'lightgray !important' : '')};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const SubTitleContainer = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row-reverse;
    margin-left: auto;
`;
